module.exports = __webpack_public_path__ + "img/redFile.0bab5a56.svg";